import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/plans/superadmin`,
});

// 📖 Get All Plans
export async function getAllPlanByAdmin() {
  try {
    const res = await API.get("/get", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ➕ Create Plan
export async function createPlanByAdmin(payload) {
  try {
    const res = await API.post("/create", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update Plan
export async function updatePlanByAdmin(planId, payload) {
  try {
    const res = await API.put(`/update/${planId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete Plan
export async function deletePlanByAdmin(planId) {
  try {
    const res = await API.delete(`/delete/${planId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
